module.exports = __webpack_public_path__ + "media/images/icons/outlined/translation-36ade498c31ed096f9bd4dd4c5973f1c.svg";